import type { LanguageDto } from "@/api/types";
import { FlagIcon } from "@/components/CustomIcons/FlagIcon";
import type { IconProps } from "@/components/Icon/Icon";

interface FlagIconProps {
  languageId: LanguageDto["id"];
  width?: number;
}
export function getFlagIcon({ languageId, width = 20 }: FlagIconProps): React.ReactElement<IconProps> | undefined {
  return <FlagIcon languageId={languageId} size={width} />;
}
